<template>
     <div 
          id="auto-carousel"
          ref="slideGroup"
          :show-arrows="false" 
          class="auto-slide-carousel d-flex">
              <div class="carousel-content" :style="{ transform: `translateX(${translateX}px)` }">
                <div v-for="(quiz, i) in displayContent" :key="i" class="ma-2">
                <v-card class="card-style h-100 d-flex flex-column my-4" flat width="300"
                style="border: 1px solid #e0e0e0; border-top: 5px solid rgb(145 213 147) !important;"
                >
                  <div class="card-header pa-5 pb-0" style="max-width: 280px;">
                    <h3 class="font-weight-bold mb-2 text-truncate" style="font-size: 1rem; line-height: 1.2; max-width: 100%;">{{ quiz.title }}</h3>
                    <p style="color: #616161; line-height: 1.6; letter-spacing: -0.02rem !important; font-size: 0.8rem; max-width: 100%; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;" class="mb-1">
                      {{ quiz.description }}
                    </p>
                  </div>

                  <div class="card-content pa-5 d-flex flex-column" style="flex: 1;">
                

                    <div class="d-flex align-center">

                      <div class="d-flex align-center rounded-lg mr-2" 
                      style="margin-right: 10px; border: 1px solid #e0e0e0; padding-right: 10px; height: 30px;"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgb(105 105 105)" stroke-width="2" 
                        style="height: 16px; width: 16px;"
                        stroke-linecap="round" stroke-linejoin="round" class="lucide ma-2 mr-1 lucide-circle-user-round-icon lucide-circle-user-round"><path d="M18 20a6 6 0 0 0-12 0"/><circle cx="12" cy="10" r="4"/><circle cx="12" cy="12" r="10"/></svg>

                        <span style="color: rgb(105 105 105) !important; font-size: 0.8rem;">{{ quiz.author }}</span>
                      </div>
                      
                      <v-spacer></v-spacer>

                      <div class="d-flex align-center rounded-lg px-2" 
                      style="border: 1px solid #e0e0e0; padding-right: 10px; min-height: 30px;"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgb(105 105 105)" stroke-width="2"
                        style="height: 18px; width: 18px;"
                        stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-timer-icon lucide-timer"><line x1="10" x2="14" y1="2" y2="2"/><line x1="12" x2="15" y1="14" y2="11"/><circle cx="12" cy="14" r="8"/></svg>
                        
                        <span style="color: rgb(105 105 105) !important; font-size: 0.8rem; margin-left: 5px;">{{ quiz.time || '2d' }}</span>
                      </div>
                      </div>

                  
                  </div>
                </v-card>
              </div>
              </div>
            </div>
        
</template>

<script>
export default {
  name: 'LastExampleCarousel',
  props: {
    popularContent: {
      type: Array,
      required: true
    }
  },

    data() {
        return {
            translateX: 0,
            animationSpeed: 1, // píxeles por frame
            animationId: null,
            duplicatedContent: false
        }
    },
    computed: {
        displayContent() {
            // Duplicar el contenido para crear efecto de ciclo continuo
            return [...this.popularContent, ...this.popularContent];
        }
    },
    mounted() {
        this.startAnimation();
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        this.stopAnimation();
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        startAnimation() {
            const animate = () => {
                this.translateX -= this.animationSpeed;
                
                // Cuando se ha desplazado todo el primer conjunto, reiniciar
                const containerWidth = this.$el.querySelector('.carousel-content').offsetWidth / 2;
                if (Math.abs(this.translateX) >= containerWidth) {
                    this.translateX = 0;
                }
                
                this.animationId = requestAnimationFrame(animate);
            };
            
            this.animationId = requestAnimationFrame(animate);
        },
        stopAnimation() {
            if (this.animationId) {
                cancelAnimationFrame(this.animationId);
                this.animationId = null;
            }
        },
        handleResize() {
            // Reiniciar la animación al cambiar el tamaño de la ventana
            this.stopAnimation();
            this.translateX = 0;
            this.startAnimation();
        }
    }
}
</script>   


<style scoped>

.auto-slide-carousel {
  position: relative;
  overflow: hidden;
}

/* Efecto de desenfoque en los laterales */
.auto-slide-carousel::before,
.auto-slide-carousel::after {
  content: '';
  position: absolute;
  top: 0;
  width: 200px;
  height: 100%;
  z-index: 2;
  pointer-events: none;
}

.auto-slide-carousel::before {
  left: 0;
  background: linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
}

.auto-slide-carousel::after {
  right: 0;
  background: linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
}

.carousel-content {
  display: flex;
  transition: transform 0.1s linear;
  will-change: transform;
}

/* Animación para dispositivos móviles */
@media (max-width: 600px) {
  .auto-slide-carousel .carousel-content {
    overflow-x: visible !important;
  }
}


/* Estilos para el carrusel automático */
.carousel-container {
  max-width: 100% !important;
  overflow: hidden;
  position: relative;
}

.auto-slide-carousel >>> .v-slide-group__prev,
.auto-slide-carousel >>> .v-slide-group__next {
  display: none !important;
}

</style>